import React from 'react'

function Evals() {
  return (
    <div>Evals</div>
  )
}

export default Evals